import {
  Currency,
  CustomerFormInfo,
  IdType,
  UseType,
  VehicleClass,
  VehicleFormInfo,
} from "./form";

export const NUMBER_REGEX = /^[0-9]+$/;
export const EMAIL_REGEX = /\S+@\S+\.\S{2,6}/;
export const PHONE_REGEX = /^[0-9]{8}$/;
export const MAX_PHONE_LENGTH = 8;

export const fieldNames = {
  [IdType.NATIONAL]: {
    idNumber: "Cédula física",
    name: "Nombre",
  },
  [IdType.PASSPORT]: {
    idNumber: "Pasaporte",
    name: "Nombre",
  },
  [IdType.RESIDENT]: {
    idNumber: "Cédula de residencia",
    name: "Nombre",
  },
};

export const MIN_NATIONAL_LENGTH = 9;

export const CURRENCY = {
  usd: "$" as Currency,
  crc: "₡" as Currency,
};

export const formInitialValues: CustomerFormInfo = {
  idType: IdType.NATIONAL,
  idNumber: "",
  name: "",
  firstLastName: "",
  secondLastName: "",
  email: "",
  phone: 0,
  valid: false,
  company: "",
};

export const vehicleInitialValues: VehicleFormInfo = {
  class: VehicleClass.PRIVATE,
  make: "",
  type: UseType.PERSONAL,
  version: "",
  model: "",
  year: 2022,
  insuranceAmount: 0,
  currency: CURRENCY.crc,
};

export const validationMessages = {
  idNumber: {
    required: "Ingrese el número de identificación",
    length: "El número de cédula debe tener 9 dígitos",
    number: "El número de cédula solo debe tener caracteres numéricos",
  },
  name: "Ingrese su nombre",
  legalName: "Ingrese la razón social",
  firstLastName: "Ingrese su primer apellido",
  email: {
    required: "Ingrese un correo electrónico",
    invalid: "Ingrese un correo electrónico válido",
  },
  phone: {
    required: "Ingrese un número de teléfono",
    invalid: "Ingrese un número de teléfono válido",
  },
};
